<template>
  <div class="w-full flex items-center flex-col justify-center">
    <h2
      :class="[
        titleClass,
        'text-[28px] xl:text-[48px] leading-130 text-dark font-bold mb-8 xl:mb-14 text-center',
      ]"
    >
      {{ title }}
    </h2>
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string;
  titleClass?: string;
}
defineProps<Props>();
</script>

<style scoped></style>
